import { render } from "./LocationNote.vue?vue&type=template&id=2b9151bf&scoped=true"
import script from "./LocationNote.vue?vue&type=script&lang=js"
export * from "./LocationNote.vue?vue&type=script&lang=js"

import "./LocationNote.vue?vue&type=style&index=0&id=2b9151bf&scoped=true&lang=css"

import exportComponent from "/home/nils/assessment_tool/code/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b9151bf"]])

export default __exports__